import { availableLocales } from '@/constants/locale';
import { isEmpty } from 'lodash';

const getLocaleInLangs = (allLangs) => {
  const localeInLangsList: any = [];
  for (let i = 0; i < allLangs.length; i += 1) {
    const localeInLangs = Object.keys(availableLocales).filter(
      (locale) => allLangs[i] === availableLocales[locale].lang
    );

    if (localeInLangs[0]) {
      localeInLangsList.push(localeInLangs[0]);
    }
  }

  return localeInLangsList;
};

const getAreaCodesListByLangs = (allLangs) => {
  if (isEmpty(allLangs)) return [];
  const localeInLangs = getLocaleInLangs(allLangs);

  const availableAreaCode = localeInLangs.map(
    (locale) => availableLocales[locale].iti
  );

  return availableAreaCode;
};

export default getAreaCodesListByLangs;
